<!--
    描述：签署抄送信息
    日期：2022/06/27
    作者：张卫华
-->
<template>
  <div class="tab-main-page">
    <div class="main-content">
      <el-row>
        <el-col :span="12">
          <span style="font-weight: bold">抄送人列表信息：</span>
        </el-col>
      </el-row>

      <div class="table-content">
        <el-table ref="xTable"
                  :data="tableObj.data"
                  highlight-current-row
                  :height="tableObj.height"
                  size="mini"
                  border>
          <el-table-column type="index"
                           label="序号"
                           align="center"
                           width="65">
          </el-table-column>
          <el-table-column prop="username"
                           label="超送人登录凭证"
                           align="center"
                           min-width="180"
                           show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="sname"
                           label="主体类型"
                           align="center"
                           min-width="180"
                           show-overflow-tooltip></el-table-column>
          <el-table-column prop="phone"
                           label="抄送主体真实信息"
                           align="center"
                           min-width="180"
                           show-overflow-tooltip></el-table-column>
        </el-table>
      </div>

      <el-row>
        <el-col :span="24">
          <span class="ml20">
            注：抄送人指不参与签署，只查看签署文件的人
          </span>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
export default {
  name : 'detail_tab_scpi',
  components: {

  },
  data() {
    return {
      tableObj : {
        currentPage: 1, // 当前页码
        pageList: [10, 20, 50, 100], // 显示条数数组
        pageSize: 10, // 当前显示条数
        total: 0, // 当前总条数
        data : [],
        height : '440px'
      },
    }
  },
  mounted() {},
  computed: {},
  // 进入缓存页面
  activated() {

  },
  watch: {},
  created() {},
  methods: {

  }
}
</script>
<style lang="less" scoped>
.tab-main-page{
  .main-content {
    font-family: 'Arial Normal', 'Arial';
    font-weight: 400;
    font-style: normal;
    font-size: 13px;
    color: #333333;
    line-height: normal;

    .el-row {
      padding : 10px 0px;
    }

    .table-content {
      margin-left: 20px;
    }
  }
}
</style>